module.exports = __webpack_public_path__ + "media/images/icon-marketplace-07e7e5050e950da0d176c4bddeba7335.png";